<template>
  <b-modal
    :title="name"
    id="group-membership-modal"
    lazy
    :busy="isBusy"
    size="xl"
  >
    <b-tabs pills v-model="tabIndex" nav-class="nav-primary">
      <b-tab lazy title="In Group">
        <StaffMembershipTable :reload="reload"></StaffMembershipTable>
      </b-tab>
      <b-tab lazy title="Available">
        <StaffMembershipAvailableTable
          :reload="reload"
        ></StaffMembershipAvailableTable>
      </b-tab>
    </b-tabs>

    <!-- begin: Modal Footer   -->
    <template #modal-footer="{ ok, cancel }">
      <b-button
        variant="secondary"
        v-on:click="destroy"
        v-if="tabIndex === 0"
        v-bind:class="{
          'spinner spinner-light spinner-right': isBusy === true,
        }"
        >Delete
      </b-button>
      <b-button
        variant="primary"
        v-on:click="save"
        v-if="tabIndex === 1"
        v-bind:class="{
          'spinner spinner-light spinner-right': isBusy === true,
        }"
        >Save
      </b-button>
      <b-button
        :disabled="isBusy"
        variant="light"
        class="btn-hover-danger"
        @click="cancel"
        >{{ $t("BUTTON.CANCEL") }}
      </b-button>
    </template>
    <!-- end: Modal Footer   -->
  </b-modal>
</template>

<script>
import { mapGetters } from "vuex";
import StaffMembershipTable from "@/modules/school/components/staff/group/membership/StaffMembershipTable";
import StaffMembershipAvailableTable from "@/modules/school/components/staff/group/membership/StaffMembershipAvailableTable";

export default {
  name: "StaffMembershipModal",
  components: { StaffMembershipAvailableTable, StaffMembershipTable },
  data: function () {
    return {
      tabIndex: 0,
      isBusy: false,
      reload: false,
    };
  },
  computed: {
    ...mapGetters({
      group: "fetchGroup",
      // isEmptyList: "getSchoolEmployeeMembershipEmpty",
    }),
    name() {
      return this.group.name ? this.group.name + " Staff Group" : "";
    },
  },
  methods: {
    save() {
      this.isBusy = true;
      this.$store
        .dispatch("saveStaffGroupMembers", {
          id: this.group.id,
        })
        .then(() =>
          this.$bvModal.msgBoxOk(this.$t("GROUP.MEMBERSHIP.ADDSUCCESS"))
        )
        .finally(() => {
          this.isBusy = false;
          this.reload = !this.reload;
        });
    },
    destroy() {
      this.isBusy = true;
      this.$store
        .dispatch("deleteStaffGroupMembers", {
          id: this.group.id,
        })
        .then(() =>
          this.$bvModal.msgBoxOk(this.$t("GROUP.MEMBERSHIP.DELETESUCCESS"))
        )
        .finally(() => {
          this.isBusy = false;
          this.reload = !this.reload;
        });
    },
  },
};
</script>

<style scoped></style>
